// extracted by mini-css-extract-plugin
export var colorBox = "Map-module--color-box--OhBmN";
export var legends = "Map-module--legends--EV+gv";
export var mapContainer = "Map-module--map-container--jZJRB";
export var toggleButtonGroup = "Map-module--toggle-button-group--UJzg-";